import ApiService from "./api.service";

const prepareFormSearch = function (form) {
  let query = {}
  query.issue_date_from = form.issue_date.start;
  query.issue_date_to = form.issue_date.end;
  if (form.type) query.type = form.type;
  return query
}

export const Materials = {
  get() {
    return ApiService.get("/materials");
  },
  add(data) {
    const {
      id,
      bodyFormData
    } = data;
    return ApiService.customRequest({
      method: 'post',
      url: `/materials${id? `/${id}`: ''}`,
      data: bodyFormData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  remove(id) {
    return ApiService.delete(`/materials/${id}`);
  },
  getCategories() {
    return ApiService.get("/materials/categories");
  },
  addCategory(data) {
    return ApiService.post("/materials/categories", data);
  },
  removeCategory(id) {
    return ApiService.delete(`/materials/categories/${id}`);
  },
  editCategory(id, body) {
    return ApiService.put(`/materials/categories/${id}`, body);
  },
  getMaterialLogs: async function (id, year) {
    let response = await ApiService.get(((!year) ? `materials/${id}` : `materials/${id}/${year}`));
    return response.data.history;
  }
};

export const WarehouseEvents = {
  search: async function (form) {
    let response = await ApiService.get("/warehouse/events", prepareFormSearch(form));
    return response.data.events;
  },
  create: async function (form) {
    let response = await ApiService.post('/warehouse/events', form);
    return response.data;
  },
  remove(id) {
    return ApiService.delete(`/warehouse/events/${id}`);
  },
  event: async function (id) {
    let response = await ApiService.get(`/warehouse/events/${id}`);
    return response.data;
  },
}

export default {
  Materials
};